"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Closer = exports.LockScroll = exports.Inner = exports.Overlay = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.Overlay = styled_components_1.default.div `
  ${({ hidden }) => (0, styled_components_1.css) `
    position: fixed;
    display: ${hidden ? "none" : "flex"};
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    z-index: 99999;
    top: 0;
    background: rgba(30, 37, 43, 0.9);
    left: 0;
  `}
`;
exports.Inner = styled_components_1.default.div `
  ${({ theme, width, disableScroll }) => (0, styled_components_1.css) `
    border-radius: 24px;
    box-shadow: 0px 63px 50px rgba(0, 0, 0, 0.05);
    box-sizing: border-box;
    background: ${theme.palette.background.default};
    max-height: 100vh;
    max-width: ${width}px;
    width: 100%;
    ${!disableScroll &&
    (0, styled_components_1.css) `
      overflow-y: overlay;
      border-width: 2px;
      border-style: solid;
      border-color: rgb(233, 235, 239);
      position: sticky;
    `}
  `}
`;
exports.LockScroll = (0, styled_components_1.createGlobalStyle) `
  html, body {
    /* TODO: fix this for homepage */
    overflow-y: ${({ locked }) => (locked ? "hidden" : "auto")};
  };

  .sticky-inner-wrapper {
    z-index: 1 !important;
  };
`;
exports.Closer = styled_components_1.default.div `
  ${({ top, right }) => (0, styled_components_1.css) `
    position: absolute;
    top: ${top}px;
    right: ${right}px;
    cursor: pointer;

    svg {
      color: #2d323b;
      opacity: 0.5;
    }
    `}
`;
//# sourceMappingURL=styled.js.map